/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ order: NonNullable<unknown>, lot: NonNullable<unknown> }} Fulfillment_Order_LotInputs */

const en_fulfillment_order_lot = /** @type {(inputs: Fulfillment_Order_LotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.order} · lot ${i?.lot}`)
};

/**
* | output |
* | --- |
* | "{order} · lot {lot}" |
*
* @param {Fulfillment_Order_LotInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const fulfillment_order_lot = /** @type {((inputs: Fulfillment_Order_LotInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Order_LotInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fulfillment_order_lot(inputs)
});